export default [
    // API Resources
    {
        path: '/api-resources',
        name: 'api-resources',
        component: () => import('../../pages/resources/api/IndexPage.vue'),
        meta: {
            title: 'API Resources',
            requiresAuth: true,
        },
    },
    {
        path: '/api-resources/:id',
        name: 'api-resources-detail',
        component: () => import('../../pages/resources/api/IndexPage.vue'),
        meta: {
            title: 'API Resource Detail',
            requiresAuth: true,
        },
    },

    // API Scopes
    {
        path: '/api-scopes',
        name: 'api-scopes',
        component: () => import('../../pages/resources/scopes/IndexPage.vue'),
        meta: {
            title: 'API Scopes',
            requiresAuth: true,
        },
    },
    {
        path: '/api-scopes/:id',
        name: 'api-scopes-detail',
        component: () => import('../../pages/resources/scopes/IndexPage.vue'),
        meta: {
            title: 'API Scope Detail',
            requiresAuth: true,
        },
    },

    // Identity Resources
    {
        path: '/identity-resources',
        name: 'identity-resources',
        component: () => import('../../pages/resources/identity/IndexPage.vue'),
        meta: {
            title: 'Identity Resources',
            requiresAuth: true,
        },
    },
    {
        path: '/identity-resources/:id',
        name: 'identity-resources-detail',
        component: () => import('../../pages/resources/identity/IndexPage.vue'),
        meta: {
            title: 'Identity Resource Detail',
            requiresAuth: true,
        },
    },
]
